export default "__VITE_ASSET__69fa82ab__"